<template>
    <div class="el-table-container">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent>
            <el-form-item prop="setMealName" label="输入搜索：">
                <el-input v-model.trim="searchForm.setMealName" maxlength="50" placeholder="请输入套餐名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('lessee:setMealList:add')" type="primary" size="small" icon="el-icon-plus" @click="addEdit(null, 'add')">新增</el-button>
                <el-button v-if="hasPermission('lessee:setMealList:del')" type="danger" size="small" icon="el-icon-delete" @click="delBefore()">批量删除</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small" height="100%"
                class="table" border ref="multipleTable" row-key='id' @selection-change="selectionChangeHandle">
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="setMealId" label="套餐ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="setMealName" label="套餐名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.status == '0'">启用</el-tag>
                    <el-tag size="small" type="danger" v-else>禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="updateByName" label="更新人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateDate" label="更新时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('lessee:setMealList:edit')" type="text" size="small"
                               @click="addEdit(scope.row, 'edit')">修改
                    </el-button>
                    <el-button v-if="hasPermission('lessee:setMealList:del')" type="text" size="small"
                               @click="delBefore(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size" @pagination="refreshList"/>
        <SetMealForm ref="setMealForm" @refreshDataList="refreshList"></SetMealForm>
        <el-dialog width="40%" :close-on-click-modal="false" append-to-body :visible.sync="delInfoFlag">
            <div class="flex_l_c m_b1">
                <el-link class="el-icon-error" type="danger" :underline="false"></el-link>
                <div>
                    <div>删除失败！</div>
                    <div class="tips">正在被使用的租户套餐不支持删除</div>
                </div>
            </div>
            <el-table
                    :data="delList"
                    v-loading="loading"
                    size="small" height="400"
                    class="table" border row-key='id'>
                <el-table-column prop="setMealId" label="套餐ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="setMealName" label="套餐名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reason" label="不可删除原因" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination :total="delTotal" :page.sync="delForm.current" :limit.sync="delForm.size" @pagination="getDelList"/>
            <div slot="footer" class="p_b1">
                <el-button size="small" @click="delInfoFlag = false">取消</el-button>
                <el-button size="small" type="primary" @click="del()" v-noMoreClick>仅删除可删除数据</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import SetMealForm from './setMealForm'

    export default {
        components: {SetMealForm},
        data() {
            return {
                loading: false,
                searchForm: {
                    setMealName: '',
                    current: 1,
                    size: 20,
                },
                dataList: [],
                total: 0,
                dataListSelections: [],
                // 删除
                delInfoFlag: false,
                delList: [],
                delTotal: 0,
                delForm: {
                    current: 1,
                    size: 20,
                },
            }
        },
        mounted() {
            this.refreshList()
        },
        methods: {
            refreshList(type) {
                if(type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.user.tenantSetMealList, this.searchForm, 'post').then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                    } else {
                        this.$message.error('查询失败');
                    }
                    this.loading = false
                })
            },
            // 新增编辑
            addEdit(row, method) {
                this.$refs.setMealForm.init(row, method)
            },
            // 删除前校验
            delBefore(id) {
                let ids = [];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据');
                    return;
                }
                if (id) {
                    ids = [id];
                } else {
                    ids = this.dataListSelections.map(item => item.id);
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.getDelList(ids, id)
                })
            },
            // 获取不可删除数据  有id为单个删除
            getDelList(data, id) {
                let ids = []
                if(data && data.length) {
                    ids = data
                } else {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$axios(this.api.user.beforeRemoveById, {
                    "ids": ids, "setMealName": "", ...this.delForm
                }, 'post').then(data => {
                    if (data.status) {
                        if(data.data.records.length) {
                            if(id) {
                                let info = data.data.records[0].reason
                                const h = this.$createElement;
                                this.$msgbox({
                                    title: '提示',
                                    message: h('p', null, [
                                        h('p', {style: 'color: #333333; margin-bottom: 5px'}, '删除失败'),
                                        h('p', {style: 'color: #999999; font-size: 12px'}, '正在'+info)
                                    ]),
                                    type: 'error',
                                    showCancelButton: true,
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                }).then(() => {})
                            } else {
                                this.delList = data.data.records
                                this.delTotal = parseInt(data.data.total)
                                this.delInfoFlag = true
                            }
                        } else {
                            this.del(ids)
                        }
                    } else {
                        this.$message.error('删除失败')
                    }
                })
            },
            // 删除
            del(data) {
                let ids = []
                if(data && data.length) {
                    ids = data
                } else {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                this.$axios(this.api.user.tenantSetMealRemoveById, ids, 'post').then(data => {
                    if (data.status) {
                        this.$message.success('删除成功')
                        this.delInfoFlag = false
                        this.$refs.multipleTable.clearSelection()
                        this.refreshList()
                    } else {
                        this.$message.error('删除失败')
                    }
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            reset() {
                this.$refs.multipleTable.clearSelection()
                this.$refs.searchForm.resetFields();
                this.refreshList(1)
            }
        }
    }
</script>

<style scoped>
    .el-icon-error {
        font-size: 24px;
        margin-right: 10px;
    }

    .tips {
        font-size: 12px;
        color: #999999;
        margin-top: 4px;
    }
</style>
